const CALENDAR_URL = `${window.location.origin}/apps/calendar`;

const calendarHeaderWidget = {
  popoverBody: null,

  isActive({ permissions, licenses }) {
    if (!permissions || !licenses) {
      return false;
    }

    const calendarLicense = licenses.some(
      (license) =>
        license &&
        license.features &&
        license.features.some((feature) => feature === 'CALENDAR_BASE_FEATURE'),
    );

    return calendarLicense;
  },

  onClickHandler: () => {
    window.location = CALENDAR_URL;

    return null;
  },
};

export default calendarHeaderWidget;
